export const edgePrimary = {
  main: { light: "#60a5fa", dark: "#3b82f6" }
};
